import { Stack } from '@mui/material';
import Amount from 'components/amount/amount.component';
import TransactionStatusChip from 'components/transaction-status-chip/transaction-status-chip.component';

const PayAmountStatus = ({ transaction }) => {
  const { chargeAmount, currency, status } = transaction ?? {};

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Amount amount={chargeAmount} currencyCode={currency} variant="h2" />
      <TransactionStatusChip status={status} />
    </Stack>
  );
};

export default PayAmountStatus;
